import { observer } from 'mobx-react';
import { useResolvedPath } from 'react-router-dom';
import { Loader } from '@servicetitan/web-components';
import { CenteredSpinner } from '@servicetitan/marketing-ui';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { PipelinesStore } from '../../stores/pipelines.store';
import { CenteredError } from '../../../../../common/components/centered-error/centered-error';

export const PipelinesPage = provide({ singletons: [PipelinesStore] })(
    observer(() => {
        const [{ src }] = useDependencies(PipelinesStore);

        const basename = useResolvedPath({
            pathname: '',
        }).pathname;

        return (
            <Loader
                src={src}
                basename={basename}
                errorFallback={<CenteredError />}
                loadingFallback={<CenteredSpinner />}
            />
        );
    }),
);
